import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { DummyPageAccessConstants } from '../shared/constants/dummy-page-access.constants';

@Injectable({
  providedIn: 'root'
})
export class DummyPageGuardService implements CanActivate, CanActivateChild {

  constructor(private authService: AuthService) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    return DummyPageAccessConstants.EMAILS.includes(this.authService.user?.email?.toLowerCase());
  }
  canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    return DummyPageAccessConstants.EMAILS.includes(this.authService.user?.email?.toLowerCase());
  }
}
